import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customPracticeQueueRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-custom-and-issue',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
	exact: true,
};
